module.exports = __webpack_public_path__ + "static/media/canvas_style.2775887f.svg";